import React, { useContext } from "react";
import { IntlContext } from "context";
import { InfiniteListPage } from "components/ListPage";
import { fetchOurServices } from "hooks/service";
import Seo from "components/Seo";
import OurServicesList from "./ListContent";
import { ROUTES } from "routes";

const Wrapper: React.FC = () => {
    const intl = useContext(IntlContext);

    return (
        <>
            <Seo
                title={intl.formatMessage("providers.seo.title")}
                description={intl.formatMessage("providers.seo.description")}
                canonical={ROUTES.PROVIDERS}
                ogType="website"
            />
            <InfiniteListPage
                title={String(intl.formatMessage("providers.list.title"))}
                titleHighlight={String(intl.formatMessage("providers.list.title_highlight"))}
                subtitle={String(intl.formatMessage("providers.list.subtitle"))}
                dataFetcher={fetchOurServices}
                defaultFetcherParams={{ order: "created_at", direction: "desc", per_page: 12 }}
                cacheKey="our-services-list"
                className="bg-violet-50"
            >
                <OurServicesList />
            </InfiniteListPage>
        </>
    );
};

export default Wrapper;
